module.exports = __webpack_public_path__ + "img/shape-metal_az_hover@2x.2c2ea261.png";